export interface Asset {
    id: number;
    name: string;
    url: string;
    type?: AssetType;
    description?: string;
    thumbnailUrl?: string;
    metadata?: Record<string, any>;
}


export enum AssetType {
    COVER = 'cover',
    LOGO = 'logo',
    IMAGE = 'image',
    VIDEO = 'video',
    DOCUMENT = 'document',
    AUDIO = 'audio',
    PDF = 'pdf',
    DOCS = 'docs',
    DOCX = 'docx',
    PPT = 'ppt',
    PPTX = 'pptx',
    CSV = 'csv',
    XLS = 'xls',
    XLSX = 'xlsx',
    OTHER = 'other'
}